import { render, staticRenderFns } from "./WidgetPremiumExpireBanner.vue?vue&type=template&id=f430e72c&scoped=true"
import script from "./WidgetPremiumExpireBanner.vue?vue&type=script&lang=js"
export * from "./WidgetPremiumExpireBanner.vue?vue&type=script&lang=js"
import style0 from "./WidgetPremiumExpireBanner.vue?vue&type=style&index=0&id=f430e72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f430e72c",
  null
  
)

export default component.exports